<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/173z77o/tc-custom/9781035844722.jpg?1734293808192" alt="This image is the cover for the book Dad’s New Dress"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dad’s New Dress
      </h1>
      <p class="bookDescription body article font2">
        <p>An email wings its way across the sea and the desert arriving in Suzie's inbox one normal Wednesday afternoon. What she discovers about her father in this email comes as a surprise to say the least. Follow her story as she struggles to cope with her emotions in the present and her memories of the past. Feel her turmoil as she examines her family relationships and tries to cope with the changes in her life. Will Suzie come to terms with her new-fangled father? Will they start to rebuild a relationship? Find out in this story, full of light and dark moments, about an ordinary woman with an extraordinary father.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Molly Anderson
      </h2>
      
      <p class="authorDescription body article">Molly Anderson lives in a small town in Wiltshire with her husband and their cat. She is very involved with her local community and, when she isn’t writing, volunteers for a number of charities and organisations. One of her passions is sustainability so she and her husband work hard at reducing their impact on the environment. She also enjoys gardening and spends a lot of time outside tending her flowers and encouraging her plants to produce fruit and vegetables.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bb9771e